export default __webpack_public_path__ + "static/media/file-waiting.6152f1f2.svg";